import { useState } from 'react';
import { Tabs, Badge } from 'antd';
import { Button, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { filter as lodashFilter, map, find, toNumber } from 'lodash-es';
// import { differenceInSeconds } from 'date-fns';
import { localDate } from '../../../utils/misc';
import { createUseStyles } from 'react-jss';
import 'antd/lib/badge/style/index.css';
import './style.scss';
// import { CSVLink } from 'react-csv';

const { TabPane } = Tabs;

/* ----------------Styles-------------- */
const useStyles = createUseStyles({
  chargerLink: {
    color: '#317ffe',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  onlineStatus: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#28a745',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  offlineStatus: {
    backgroundColor: '#e61b1b',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#e61b1b',
      color: 'white',
      boxShadow: 'none',
    },
    boxShadow: 'none',
  },
  pageNum: {
    fontWeight: 'bold',
    paddingRight: '10px',
    paddingLeft: '10px',
    paddingTop: '6px',
  },
  activePageNum: {
    backgroundColor: '#2675b8',
    color: 'white',
    borderRadius: '5px',
  },
  pagination: {
    display: 'flex',
    listStyle: 'none',
    paddingLeft: '0px',
    justifyContent: 'flex-end',
  },
});

const ChargersList = ({ data, isLoading }) => {
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [chargersPageNum, setChargersPageNum] = useState(
    toNumber(localStorage.getItem('chargersPageNum')) || 1,
  );
  // const [selectedCharger, setSelectedCharger] = useState({});
  // const limit = 100;
  // const [chargerLocationModalOpen, setChargerLocationModalOpen] =
  //   useState(false);
  // const toggleChargerLocationModal = () =>
  //   setChargerLocationModalOpen(!chargerLocationModalOpen);

  // const { data: listchargers, isLoadinglist } = useHostChargersList({
  //   limit,
  //   offset: calculatePageOffset(limit, chargersPageNum),
  //   page: chargersPageNum,
  // });

  // useEffect(() => {
  //   if (chargers?.list > 0) {
  //     setData(chargers);
  //   }
  // }, [chargers]);

  const allFilters = [
    { name: 'All', key: 'all', filter: {}, color: '#000000' },
    {
      name: 'Online',
      key: 'online',
      filter: { IS_AVAILABLE: 1 },
      color: '#52c41a',
    },
    {
      name: 'Offline',
      key: 'offline',
      filter: { IS_AVAILABLE: 0, IS_ENABLED: 1 },
      color: 'red',
    },
    {
      name: 'Enabled',
      key: 'enabled',
      filter: { IS_ENABLED: 1 },
      color: '#5e72e4',
    },
    {
      name: 'Disabled',
      key: 'disabled',
      filter: { IS_ENABLED: 0 },
      color: 'grey',
    },
  ];

  const [filter, setFilter] = useState('all');
  // const [filter, setFilter] = useQueryParam(
  //   'filter',
  //   withDefault(StringParam, 'online'),
  // );

  const filterChargersByStatus = (status) => {
    if (!data) return '';
    const cData =
      status === 'all'
        ? data?.list
        : lodashFilter(data?.list, find(allFilters, { key: status }).filter);
    return cData;
  };

  function isChargerOnline(charger) {
    // Temperorily commented on JYOTISMAN Request (22/6/2025) 
    /* const { LAST_HEARTBEAT } = charger;
    let chargerConfig = {};
    if (get(charger, 'CHARGER_CONFIGURATION')) {
      chargerConfig = JSON.parse(get(charger, 'CHARGER_CONFIGURATION'));
    }

    const chargerHearBeatConfigObj = find(
      get(chargerConfig, 'configurationKey'),
      { key: 'HeartbeatInterval' },
    );
    const chargerHeartBeatInterval = toNumber(
      get(chargerHearBeatConfigObj, 'value'),
    );
    const diffInSeconds = differenceInSeconds(
      new Date(),
      new Date(LAST_HEARTBEAT),
    );
    return diffInSeconds <= chargerHeartBeatInterval; */
    return charger?.IS_AVAILABLE;
  }

  const getChargersCountByStatus = (key) => {
    const cData = filterChargersByStatus(key);
    return cData ? cData?.length : '0';
  };

  const tabChangeHandler = (key) => {
    setFilter(key);
  };

  const getBadgeColourByStatus = (status) =>
    find(allFilters, { key: status }).color;

  return (
    <div className="tabs-container">
      <Tabs
        activeKey={filter}
        onTabClick={(key) => {
          tabChangeHandler(key);
        }}
        className="w-full"
      >
        {allFilters.map(({ name, key }) => (
          <TabPane
            tab={
              <span style={{ marginLeft: 20 }}>
                {name}&nbsp;
                <Badge
                  style={{
                    backgroundColor: getBadgeColourByStatus(key),
                    fontSize: '18px',
                  }}
                  count={getChargersCountByStatus(key) || 0}
                  overflowCount={999}
                />
              </span>
            }
            key={key}
          >
            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">id</th>
                  <th scope="col">name</th>
                  <th scope="col">state</th>
                  <th scope="col">Type</th>
                  <th scope="col">Created at</th>
                  <th scope="col">Status</th>
                  {/* <th scope="col" /> */}
                </tr>
              </thead>
              {isLoading ? null : (
                <tbody>
                  {map(filterChargersByStatus(filter), (cp, c) => (
                    <tr key={c}>
                      <th scope="row">
                        <Link
                          to={`/admin/chargers/${cp.ID}`}
                          className={classes.chargerLink}
                        >
                          <span className="mb-0 text-sm">#{cp.ID}</span>
                        </Link>
                      </th>
                      <td>{cp.NAME}</td>
                      <td>
                        {cp.STATE}
                        {/* <div className="d-flex align-items-center">
                          <span className="mr-2">
                            {' '}
                            <Button
                              variant="primary"
                              style={{
                                backgroundColor: '#2675b8',
                                border: 'none',
                                color: 'white',
                                borderRadius: '4px',
                              }}
                              size="sm"
                              onClick={() => {
                                setSelectedCharger(cp);
                                toggleChargerLocationModal();
                              }}
                            >
                              Show Map
                            </Button>
                          </span>
                        </div> */}
                      </td>
                      <td>{cp.IS_DC ? 'DC' : 'AC'}</td>
                      <td>{localDate(cp.CREATED_AT)}</td>
                      <td>
                        {isChargerOnline(cp) ? (
                          <Button
                            onClick={(e) => e.preventDefault()}
                            size="sm"
                            className={classes.onlineStatus}
                          >
                            Online
                          </Button>
                        ) : (
                          <Button
                            onClick={(e) => e.preventDefault()}
                            size="sm"
                            className={classes.offlineStatus}
                          >
                            Offline
                          </Button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </TabPane>
        ))}
      </Tabs>
    </div>
  );
};

export default ChargersList;
